
const topArea = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let secSrea = document.querySelector('#jsSecSrea');
    let listWrap = secSrea.querySelector('.js-list-wrap');
    let listAreas = listWrap.querySelectorAll('.js-list-area');

    listAreas.forEach((element, index) => {

      let acdoBox = element.querySelector('.js-acdo-box');
      let acdoBoxin = element.querySelector('.js-acdo-box-inner');

      acdoBox.style.height = `${0}px`

      element.addEventListener('click', () => {
        let acdoBoxinH = acdoBoxin.clientHeight;
        // console.log(acdoBoxinH)

        if (element.classList.contains('is-act') == true) {
          element.classList.remove('is-act');
          acdoBox.style.height = `${0}px`
        } else {
          element.classList.add('is-act');
          acdoBox.style.height = `${acdoBoxinH}px`
        }
      });


    });



  }
})()
export default topArea;